export function broadenPeaks(peakList, options = {}) {
    const { factor = 2, overlap = false } = options;
    const peaks = JSON.parse(JSON.stringify(peakList));
    peaks.forEach((peak) => {
        peak.from = peak.x - (peak.width / 2) * factor;
        peak.to = peak.x + (peak.width / 2) * factor;
    });
    if (!overlap) {
        for (let i = 0; i < peaks.length - 1; i++) {
            let peak = peaks[i];
            let nextPeak = peaks[i + 1];
            if (peak.to > nextPeak.from) {
                peak.to = nextPeak.from = (peak.to + nextPeak.from) / 2;
            }
        }
    }
    for (let peak of peaks) {
        peak.width = peak.to - peak.from;
    }
    return peaks.map((peak) => {
        const { x, y, width, shape } = peak;
        const peakResult = { x, y, width };
        if (shape)
            peakResult.shape = shape;
        return peakResult;
    });
}
//# sourceMappingURL=broadenPeaks.js.map